module.exports = __webpack_public_path__ + "img/id.fbe7abf8.svg";